import React from "react";

import { fetchAuthSession } from "@aws-amplify/auth";
import axios, { AxiosRequestConfig } from "axios";

interface IProps {
	requestMatcher?: (r: AxiosRequestConfig) => boolean;
}

const AxiosInterceptor: React.FC<IProps> = (props) => {
	const matcher = props.requestMatcher || ((_) => true); // eslint-disable-line
	axios.interceptors.request.use(async (request) => {
		if (matcher(request)) {
			const { tokens } = await fetchAuthSession();
			if (request.headers !== undefined && tokens?.idToken) {
				request.headers["Authorization"] = `Bearer ${tokens.idToken.toString()}`;
			}
		}
		return request;
	});
	return <></>;
};

export default AxiosInterceptor;
